module.exports = __webpack_public_path__ + "img/item2.7b8d06bb.png";